export const recommend = {
  liveSection: {
    title: "配信している女の子",
  },
  instantCallSection: {
    title: "今すぐビデオ通話できる女の子",
  },
  footprintSection: {
    title: "あなたの事に興味がある女の子",
  },
  highReviewSection: {
    title: "評価が高い女の子",
  },
  goDiscoverButton: "さがす画面でもっと探す",
  /** ヘッダー左のお知らせ「ポイント購入が10％お得！」 */
  purchaseNotice: {
    listTitle: "ポイント購入が10％お得！",
    title: "web決済で\nお得にポイントを購入できます",
    body: {
      line1:
        "ApplePay・クレジットカード・Paidyでの決済なら\nアプリ内課金よりもポイントが",
      emphasis: "10%増量",
      line2: "されます。",
    },
    purchase: "確認する",
    close: "閉じる",
  },
  recentLoginSection: {
    title: "最近ログインした女の子",
  },
  sadisticSection: {
    title: "Sな性格の女の子",
  },
  masochisticSection: {
    title: "Mな性格の女の子",
  },
  rankingSection: {
    title: "ビデオ通話ランキング",
    rankLabel: { 1: "1st", 2: "2nd", 3: "3rd" },
  },
} as const;
